import { useEffect, useState } from 'react';

/** Live `matchMedia` result. */
export function useMedia(query: string) {
  const [match, setMatch] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
  useEffect(() => {
    const m = window.matchMedia(query);
    const on = () => setMatch(m.matches);
    on();
    m.addEventListener('change', on);
    return () => m.removeEventListener('change', on);
  }, [query]);
  return match;
}

/** Phones and small tablets in portrait (below Tailwind's `md`). */
export const useNarrow = () => useMedia('(max-width: 767px)');
